var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 140,
    viewBox: "0 0 200 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.406 135.738C162.996 129.062 184.692 110.704 196.374 86.7834C200.268 78.439 202.493 67.313 195.261 61.75C190.255 57.8559 183.579 58.9685 177.46 59.5248L80.1077 75.1012C66.7565 77.3264 51.7365 81.2204 50.0676 97.3531C48.955 107.366 53.4054 119.605 61.1936 126.281C78.9951 140.744 116.823 141.301 137.406 135.738Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4443 136.293C101.802 140.743 123.498 139.631 137.405 135.736C142.412 134.624 146.862 132.399 151.869 130.73C144.081 111.259 123.498 101.246 105.14 107.922C92.9014 112.372 85.1132 123.498 83.4443 136.293Z",
    fill: "#FF7192"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6097 20.0267C40.6097 31.1527 31.709 40.0534 20.583 40.0534C8.90076 40.6097 0 31.709 0 20.0267C0 8.34446 8.90076 0 20.0267 0C31.709 0 40.6097 8.90076 40.6097 20.0267Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.636 20.0267C144.636 31.1527 135.736 40.0534 124.61 40.0534C113.484 40.0534 104.583 31.1527 104.583 20.0267C104.583 8.90076 112.927 0 124.61 0C135.736 0 144.636 8.90076 144.636 20.0267Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceHappy);
export default __webpack_public_path__ + "static/media/face_happy.6d40abc790cda3a85706da03d7d4f24d.svg";
export { ForwardRef as ReactComponent };